<template>
  <el-dialog
    custom-class="tip-dialog"
    :visible="visible"
    :close-on-click-modal="false"
    top="0"
    :close-on-press-escape="false"
    :show-close="false"
    :width="width"
    center
  >
    <div class="tip-container">
      <div class="header">
        <h3 class="title">{{ title }}</h3>
      </div>
      <p class="subtitle">{{ subtitle }}</p>
      <p :class="['description', subtitle ? 'pt1' : 'pt2']">
        {{ message }}
      </p>

      <div class="footer">
        <button
          @click="handleCancel"
          v-if="leftButtonText"
          :class="['dialog-btn cancel-btn']"
        >
          {{ leftButtonText }}
        </button>
        <button
          @click="handleConfirm"
          v-if="rightButtonText"
          :class="['dialog-btn confirm-btn', type]"
        >
          {{ rightButtonText }}
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "TipDialog",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    rightButtonText: {
      type: String,
      default: "",
    },
    leftButtonText: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "600px",
    },
    subtitle: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "", // primary | danger | udesk-go-service
    },
  },
  methods: {
    handleCancel() {
      this.$emit("dialog-cancel");
    },
    handleConfirm() {
      this.$emit("dialog-confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tip-dialog {
  top: 50%;
  transform: translateY(-50%);

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.tip-container {
  padding: 40px;
  word-break: break-word;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 18px;
      line-height: 1;
      font-weight: 500;
      margin: 0 auto;
      color: #212322;
    }
  }

  .description {
    padding: 24px 0 32px 0;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
    text-align: center;

    &.pt1 {
      padding-top: 8px;
    }
    &.pt2 {
      padding-top: 24px;
    }
  }

  .subtitle {
    padding-top: 20px;
    font-size: 16px;
    color: #212322;
    text-align: center;
  }

  .footer {
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  .dialog-btn {
    max-width: 50%;
  }

  .cancel-btn {
    flex: 1;
    background-color: white;
    border: 1px solid #7f0019;
    border-radius: 0;
    padding: 12px 20px;
    color: #7f0019;
    cursor: pointer;
  }

  .confirm-btn {
    flex: 1;
    background-color: #7f0019;
    color: white;
    border: none;
    border-radius: 0;
    padding: 12px 20px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 768px) {
  ::v-deep .tip-dialog {
    width: 95% !important;
  }

  // 在移动端让文本更小而不改变布局结构
  .tip-container {
    padding: 24px 20px;

    .description {
      padding: 24px 16px 32px 16px;
      line-height: 20px;
      font-size: 12px;
      &.pt1 {
        padding-top: 8px;
      }
      &.pt2 {
        padding-top: 24px;
      }
    }

    .subtitle {
      padding-top: 20px;
      font-size: 14px;
      color: #212322;
      text-align: center;
    }
  }
}
</style>
